import { useState } from 'preact/hooks';

import { Numpad } from '../components/Numpad';
import type { ScreenLock } from '../screen-lock';

interface Props {
  lock: ScreenLock;
  stationName: string;
}

export function LockView({ lock, stationName }: Props) {
  const [pin, setPin] = useState('');
  const [error, setError] = useState(false);

  function submit(): void {
    if (lock.unlock(pin)) {
      setPin('');
      setError(false);
      return;
    }
    setError(true);
    setPin('');
  }

  return (
    <div class="screen screen--lock">
      <h1>Gesperrt</h1>
      <p class="lead">{stationName}</p>

      <output class="display" aria-label="PIN">
        {'•'.repeat(pin.length) || '—'}
      </output>

      {error && (
        <p class="error" role="alert">
          Falsche PIN
        </p>
      )}

      <Numpad
        value={pin}
        onChange={(v) => {
          setError(false);
          setPin(v.slice(0, 4));
        }}
        onSubmit={submit}
      />
    </div>
  );
}
